import { render } from "./InputIcon.vue?vue&type=template&id=0ba0e9f1&scoped=true"
import script from "./InputIcon.vue?vue&type=script&lang=js"
export * from "./InputIcon.vue?vue&type=script&lang=js"

import "./InputIcon.vue?vue&type=style&index=0&id=0ba0e9f1&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba0e9f1"]])

export default __exports__